import * as React from "react";
import { withRxForm, RxFormField, RxFormFieldDef, RxFormFieldDefs, RxFormProps } from "components/rx-form";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { isDefined } from "components/utils";
import { buildValidator, ValidatorFields } from "components/validators";
import { Button, Grid } from "components/controls/widget";
import TextInput from "components/controls/inputs/TextInput";
import DateInput from "components/controls/inputs/DateInput";
import FileInput from "components/controls/inputs/FileInput";
import SelectInput, { selectInputItems } from "components/controls/inputs/SelectInput";
import Group from "common/web/Group";
import Alert from "common/components/controls/Alert";
import Error from "common/components/controls/Error";

import fields from "./fields";
import { seznamUmisteniVeFinale, seznamDisciplin, seznamVekovychKategorii, seznamVykonnostnichTrid, seznamPoctuKolClenu } from "./collections";


interface ZadostFormProps {
    ziskaneBody: string;
    ziskaneFinale: string;
}

class ZadostForm extends React.Component<ZadostFormProps & RxFormProps & WithStyles<typeof styles>>{

    render() {

        const { ziskaneBody, ziskaneFinale, handleSubmit, submitting, globalError, fields, classes } = this.props;


        return <form onSubmit={handleSubmit}>
            <div className={classes.content}>
                <Grid container spacing={16} wrap="nowrap" direction="column" justify="space-between">
                    <Grid item>
                        <Group title={'Akce'}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={6} md={2}>
                                    <DateInput {...fields["SoutDatum"]} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextInput {...fields["SoutNazev"]} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextInput {...fields["SoutMisto"]} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextInput {...fields["SoutStat"]} fullWidth />
                                </Grid>
                            </Grid>
                        </Group>
                    </Grid>
                    <Grid item>
                        <Group title={'Soutěž'}>
                            <Grid container spacing={40} wrap="nowrap" direction="column" justify="space-between">
                                <Grid item>
                                    <Grid container spacing={16} justify="space-between">
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectInput {...fields["SoutVekKtg"]} fullWidth items={seznamVekovychKategorii} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectInput {...fields["SoutVykTrida"]} fullWidth items={seznamVykonnostnichTrid} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectInput {...fields["SoutDisciplina"]} fullWidth items={seznamDisciplin} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextInput {...fields["SoutPocetParu"]} fullWidth />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>

                                    <Grid container spacing={16}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextInput {...fields["ParPocetKol"]} fullWidth />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectInput {...fields["SoutPocKolektivnichClenu"]} fullWidth items={seznamPoctuKolClenu} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextInput {...fields["ParUmisteni"]} fullWidth />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <SelectInput {...fields["ParVeFinale"]} fullWidth items={seznamUmisteniVeFinale} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Group>
                    </Grid>
                    <Grid item>
                        <Group title={'Doložení výsledků'}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <TextInput {...fields["DolozeniUrlAdresa"]} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <FileInput {...fields["DolozeniSoubor"]} fullWidth />
                                </Grid>
                            </Grid>
                        </Group>
                    </Grid>

                    <Grid item>
                        <Group title={'Získané body'}>
                            <div><span>Počet získaných bodů: </span>{ziskaneBody}</div>
                            <div><span>Získané finále: </span>{ziskaneFinale}</div>
                        </Group>
                    </Grid>

                    {globalError && <Grid item>
                        <Error noPadding noCenter>{globalError}</Error>
                    </Grid>}


                    <Grid item>
                        <Button type="submit" disabled={submitting}>{'Odeslat'}</Button>
                    </Grid>



                </Grid>
            </div>
        </form>
    }
}


export const styles = (theme: Theme) => createStyles({
    content: {
        padding: 2 * theme.spacing.unit
    },
});

export default withStyles(styles)(withRxForm(fields, buildValidator(fields))(ZadostForm));
